import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { PrintServices } from "../../../services/printServices";
import { ConfigurationServices } from '../../../configuration/services';
import { OrdersCoServices } from '../../services';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the TpvTicketSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-orders-select-selected',
    templateUrl: 'orders-select-selected.html',
})
export class OrdersSelectSelectedPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public ordersCoServices: OrdersCoServices,
        public globals: Globals,
        private alertCtrl: AlertController,
        public printServices: PrintServices,
        public configurationServices: ConfigurationServices,
        private loadingCtrl: LoadingController,
        public translate: TranslateService) {
    }

    ionViewDidLoad() {

    }

    styleHeight() {
        //get height screen
        var height = window.innerHeight;
        if ((this.globals.trial_days > 0 && this.globals.trial_days <= 15) || (this.globals.trial_days == 0 && this.globals.restaurant.license === 'free')) {
            height = height - 91;
        } else {
            height = height - 51;
        }
        height = height / 2;
        let styles = {
            'height': height + 'px',
            'overflow': 'hidden',
        };
        return styles;
    }

    openSendOrder() {
        const confirm = this.alertCtrl.create({
            title: this.translate.instant('instant-enviar-comanda'),
            message: this.translate.instant('instant-seguro-quieres-enviar-comanda'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    handler: () => {

                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.sendOrder();
                    }
                }
            ]
        });
        confirm.present();
    }



    async sendOrder() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        await this.ordersCoServices.sendOrderInServices();
        //this.globals.side_menu_active = 'order';
        //this.navCtrl.push(OrdersRoomPage);
        this.globals.side_menu_active = 'order';
        loadingPopup.dismiss();
        this.navCtrl.pop();
    }

    async openModSelect() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        await this.ordersCoServices.openModSelect();
        this.ordersCoServices.count_elements = 0;//reset
        loadingPopup.dismiss();
        this.navCtrl.pop();
        this.navCtrl.pop();
    }

}


// WEBPACK FOOTER //
// ./src/pages/orders/orders-select/orders-select-selected/orders-select-selected.ts